import axios from '@/axiosInterceptor';

const state = () => ({
  isTypes: {},
});

// getters
const getters = {
  isTypes(state) {
    //Create an auxiliar array.
    let arrayOfTypes = [];

    //Convert the object in a different structure using the entries of the Object
    const types = Object.entries(state.isTypes);

    //Iterate and extract the value of the object
    types.forEach((t) => {
      arrayOfTypes.push(Object.entries(t)[1][1].name);
    });

    return arrayOfTypes;
  },
};

// actions
const actions = {
  async getIsTypes({ commit }) {
    try {
      const res = await axios.get(
        process.env.API_MONITOR + '/api/v1/insurance_exclusions/is_types'
      );
      commit('setIsTypes', res.data);
      return res;
    } catch (e) {
      const status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setIsTypes(state, data) {
    state.isTypes = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
